<template>
  <Modal title="学员定级" v-model="visible" width="650">
    <Form ref="modalForm" class="form"
          :model="formData" :rules="formRule"
          :label-width="80">
      <Row>
        <i-col :span="22">
          <Form-item label="学生信息">
            <label>{{ formData.uid }}  - {{ formData.mobile }} - {{ formData.nickname }}</label>
          </Form-item>
        </i-col>
        <i-col :span="12">
          <Form-item label="Level" prop="levelId">
            <Select filterable v-model.number="formData.levelId" transfer>
              <Option v-for="item in bookMaterialLevelList"
                      :value="item.id" :key="item.id">{{ item.title }}(版本{{item.materialVersion}})
              </Option>
            </Select>
          </Form-item>
        </i-col>
      </Row>
    </Form>
    <div slot="footer">
      <Button type="text" size="large" @click="visible=false">取消</Button>
      <Button type="primary" size="large" :loading="loadingBind" @click="updateLevel" >确定</Button>
    </div>
  </Modal>
</template>
<script>
  export default {
    name: 'UpdateLevelModal',
    props: {
      value: {
        type: Boolean,
        default: false
      },
      user: {
        type: Object
      },
      successCallback: {
        type: Function
      }
    },
    data () {
      return {
        visible: this.value,
        loadingBind: false,
        bookMaterialLevelList: null,
        formData: {
          uid: '',
          nickname: '',
          mobile: '',
          levelId: null,
        },
        formRule: {
          levelId: [
            {type: 'integer', required: true, message: '请选择Level', trigger: 'change'}
          ]
        }
      }
    },
    methods: {
      loadBookMaterialLevel () {
        let self = this
        self.$http.get('/bookMaterialLevel/listByCondition?status=1&ptype=2').then(function (res) {
          if (!res || !res.data) {
            return
          }
          self.bookMaterialLevelList = res.data
          self.visible = true
        })
      },
      updateLevel () {
        let self = this
        let isNotError = true
        self.loadingBind = true
        self.$refs.modalForm.validateField('levelId', (valid) => {
          if (valid !== '') isNotError = false
        })
        if (!isNotError) {
          self.loadingBind = false
          return
        }

        let params = {}
        params.uid = self.formData.uid
        params.levelId = self.formData.levelId
        self.$http.post('/userList/updateLevel', params).then(function (res) {
          self.$Message.success('操作成功!')
          self.visible = false
          self.loadingBind = false
          self.successCallback()
        })
      },
      onClose () {
        this.$emit('on-close')
      }
    },
    watch: {
      value (val) {
        if (val === true) {
          this.formData.uid = this.user.id
          this.formData.nickname = this.user.nickname
          this.formData.mobile = this.user.mobile
          this.loadBookMaterialLevel()
        } else {
          this.formData = {
            uid: '',
            nickname: '',
            mobile: '',
            levelId: null,
          }
          this.$refs.modalForm.resetFields()
          this.bookMaterialLevelList = []
          this.visible = val
        }
      },
      visible (val) {
        this.$emit('input', val)
      }
    }
  }
</script>



// WEBPACK FOOTER //
// UpdateLevelModal.vue?24fe4fe6